<template>
  <b-container fluid>
    <b-form @submit.prevent="submit">
      <b-row class="mb-3">
        <b-col cols="9">
          <h1 class="font-weight-bold text-primary">Repair #{{ repair.id }}</h1>
        </b-col>
        <b-col cols="3">
          <b-button v-if="!repair.cancelled_at && !repair.repair_complete" :variant="!cancelRepairClicked ? 'danger' : 'dark'" class="ml-2 float-right" @click="cancelRepair">{{ cancelRepairClicked ? 'Are you sure?' : 'Cancel' }}</b-button>
          <b-button v-if="repair.cancelled_at && !repair.repair_complete" variant="outline-danger" class="ml-2 float-right">Cancelled</b-button>
        </b-col>
      </b-row>
      <b-row v-if="isLoading">
        <b-col cols="12">
          <p class="text-center"><b-spinner variant="secondary"></b-spinner></p>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col cols="12">
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Name" :invalid-feedback="validationInvalidFeedback(errors, 'name')">
                <b-form-input :disabled="true" :state="validationState(errors, 'name')" v-model="repair.ticket.name" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Email" :invalid-feedback="validationInvalidFeedback(errors, 'email')">
                <b-form-input :disabled="true" :state="validationState(errors, 'email')" v-model="repair.ticket.email" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Phone" :invalid-feedback="validationInvalidFeedback(errors, 'phone')">
                <b-form-input :disabled="true" :state="validationState(errors, 'phone')" v-model="repair.ticket.phone" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="SPA Serial Number" :invalid-feedback="validationInvalidFeedback(errors, 'spa')">
                <b-form-input :disabled="true" :state="validationState(errors, 'spa')" v-model="repair.ticket.spa" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Status" :invalid-feedback="validationInvalidFeedback(errors, 'status')">
                <b-form-input :disabled="true" :state="validationState(errors, 'status')" v-model="repair.ticket.status" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Description of the Fault" :invalid-feedback="validationInvalidFeedback(errors, 'description')">
                <b-form-textarea :disabled="true" :state="validationState(errors, 'description')" v-model="repair.ticket.description" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col class="d-flex flex-row" cols="12" md="9" @click.prevent="toggleCollapse('address')" role="button">
                    <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['address'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                    <div class="d-flex flex-column flex-fill ml-4">
                      <p class="h4 font-weight-bold mb-0">Address</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4" v-if="!collapsed['address']">
                  <b-col cols="12">
                    <b-form-group label="Address Line 1" :invalid-feedback="validationInvalidFeedback(errors, 'address.address_line_1')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.address_line_1')" v-model="repair.ticket.ticket_address.address_line_1" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Address Line 2" :invalid-feedback="validationInvalidFeedback(errors, 'address.address_line_2')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.address_line_2')" v-model="repair.ticket.ticket_address.address_line_2" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="City" :invalid-feedback="validationInvalidFeedback(errors, 'address.city')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.city')" v-model="repair.ticket.ticket_address.city" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="County" :invalid-feedback="validationInvalidFeedback(errors, 'address.county')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.county')" v-model="repair.ticket.ticket_address.county" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="Postcode" :invalid-feedback="validationInvalidFeedback(errors, 'address.postcode')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.postcode')" v-model="repair.ticket.ticket_address.postcode" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4">
              <b-col cols="12">
                  <b-card>
                      <b-row>
                          <b-col class="d-flex flex-row" cols="12" md="6" @click.prevent="toggleCollapse('ticket_notes')" role="button">
                              <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['ticket_notes'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                              <div class="d-flex flex-column flex-fill ml-4">
                                  <p class="h4 font-weight-bold mb-0">Notes</p>
                              </div>
                          </b-col>
                      </b-row>
                      <b-row class="mt-4" v-if="!collapsed['ticket_notes']">
                          <b-col cols="12" v-if="repair.ticket.notes.length">
                              <hr />
                              <b-row v-for="(note, noteInd) in repair.ticket.notes" :key="noteInd">
                                  <b-col cols="12" :invalid-feedback="validationInvalidFeedback(errors.errors, 'note.' + noteInd + '.note')">
                                      <b-card no-body class="p-4 mt-3">
                                        <b-row>
                                          <b-col cols="12">
                                            <p class="note mb-0 white-space-pre">{{ note.note }}</p>
                                          </b-col>
                                        </b-row>
                                        <hr />
                                        <b-row>
                                            <b-col cols="9" class="d-flex flex-row justify-content-start align-items-center">
                                                <p class="note-created mb-0">Left by: {{ note.user.name }}</p>
                                            </b-col>
                                            <b-col cols="3" class="d-flex flex-row justify-content-end align-items-center">
                                                <p class="note-created text-muted mb-0"><FriendlyDate :date="note.created_at"></FriendlyDate></p>
                                            </b-col>
                                        </b-row>
                                      </b-card>
                                  </b-col>
                              </b-row>
                          </b-col>
                      </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col class="d-flex flex-row" cols="12" md="9" @click.prevent="toggleCollapse('image_collapse')" role="button">
                    <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['image_collapse'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                    <div class="d-flex flex-column flex-fill ml-4">
                      <p class="h4 font-weight-bold mb-0">Images</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4" v-if="!collapsed['image_collapse']">
                  <b-col cols="12" md="12">
                    <h4>Serial Number Image</h4>
                    <b-img :src="returnFileUrl('serial_number_image')" fluid block></b-img>
                  </b-col>
                  <b-col cols="12" md="12">
                    <h4>Hot Tub Image</h4>
                    <b-img :src="returnFileUrl('hot_tub_image')" fluid block></b-img>
                  </b-col>
                  <b-col cols="12" md="12">
                    <h4>Problem File</h4>
                    <b-img v-if="returnTicketFileType('problem_file') == 'image'" :src="returnTicketFileUrl('problem_file')" fluid block></b-img>
                    <video class="w-100" v-if="returnTicketFileType('problem_file') == 'video'" :src="returnTicketFileUrl('problem_file')" controls></video>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col class="d-flex flex-row" cols="12" md="9" @click.prevent="toggleCollapse('repair')" role="button">
                    <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['repair'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                    <div class="d-flex flex-column flex-fill ml-4">
                      <p class="h4 font-weight-bold mb-0">Repair</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4" v-if="!collapsed['repair']">
                  <b-col cols="12">
                    <b-form-group label="Team" :invalid-feedback="validationInvalidFeedback(errors, 'repair.team_id')">
                      <b-card>
                        <b-row>
                          <b-col cols="12">
                            <p class="mb-0">{{ repair.team.name }}</p>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-form-group>
                    <b-form-group label="Repair Date" :invalid-feedback="validationInvalidFeedback(errors, 'repair.repair_date')">
                      <b-form-datepicker :disabled="true" v-model="repair.repair_date" />
                    </b-form-group>
                    <b-form-group label="Duration (Minutes)" :invalid-feedback="validationInvalidFeedback(errors, 'repair.duration')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'repair.duration')" v-model="repair.duration" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4" v-if="!isLoading">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="12" sm="7" clsass="d-flex flex-row align-items-center">
                        <div class="w-100 d-flex flex-row" @click.prevent="toggleCollapse('dispatched_messages')" role="button">
                          <b-icon class="cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['dispatched_messages'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                          <div class="d-flex flex-column flex-fill ml-4">
                            <p class="h4 font-weight-bold mb-0">Dispatched Messages</p>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="!collapsed['dispatched_messages']">
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-row :class="repair.dispatched_messages.length ? 'mt-4' : ''" v-if="!collapsed['dispatched_messages']">
                  <b-col cols="12" v-if="!repair.dispatched_messages.length" class="p-4">
                    <b-row>
                      <b-col class="text-center" cols="12">
                        <b-card class="py-3 text-center">
                          <p class="mb-4"><fa-icon class="display-1 text-dark" icon="times"></fa-icon></p>
                          <p class="font-weight-normal h5 mb-0 text-dark">There have been no dispatched messages to this customer.</p>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" v-if="repair.dispatched_messages.length">
                    <b-card no-body>
                      <b-row v-for="(message, messageInd) in repair.dispatched_messages" :key="messageInd">
                        <b-col cols="12">
                          <b-row v-if="messageInd > 0">
                            <b-col cols="12">
                                <div class="m-3"><hr></div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="7" class="d-flex flex-row align-items-center">
                              <div class="mt-3 ml-3 mb-0 mb-md-3">
                                <h5 v-if="message.subject">{{ message.subject }}</h5>
                                <h5 v-if="!message.subject">{{ message.type }}</h5>
                                <small class="text-small text-muted" v-if="message.read_at">Read At: {{ moment(message.read_at).format('DD/MM/YYYY') }}<br></small>
                                <small class="text-muted" v-if="message.subject">{{ message.type }}</small>
                              </div>
                            </b-col>
                            <b-col cols="12" md="5" class="d-flex flex-column flex-fill align-items-start justify-content-start align-items-md-end w-100 max-width">
                              <div class="ml-3 mr-3 mt-0 mt-md-3">
                                <small class="text-right"><span class="text-muted">{{ moment(message.created_at).format('DD/MM/YYYY @ HH:MM') }}</span></small>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12">
                                <div class="m-3"><hr></div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12">
                                <div class="m-3" v-html="message.content">
                                </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import FriendlyDate from '../../components/FriendlyDate'
import validation from '../../mixins/validation'
import { mapActions, mapGetters } from 'vuex'
import momentMixin from '../../mixins/momentMixin'

export default {
  mixins: [validation, momentMixin],
  components: { FriendlyDate },
  computed: {
    ...mapGetters('repairs', ['errors', 'isLoading', 'isSaving', 'single'])
  },
  data () {
    return {
      collapsed: {
        address: true,
        repair: false,
        image_collapse: true,
        ticket_notes: true,
        dispatched_messages: true,
      },


      serial_number_image: null,
      hot_tub_image: null,
      problem_file: null,
      
      repair: {
        id: null,
        ticket_id: null,
        team_id: null,
        team: { id: null },
        repair_date: null,
        duration: null,
        repair_note: null,
        ticket: { id: null },
      },
      cancelRepairClicked: false,
    }
  },
  created() {
    var self = this;
    if (this.$route.params.id) {
      this.fetch(this.$route.params.id)
    }
  },
  methods: {

    ...mapActions('repairs', ['fetch', 'save']),

    toggleCollapse (name) {
      this.collapsed[name] = !this.collapsed[name]
    },

    teamUpdated() {
      this.repair.team_id = this.repair.team.id;
    },

    submit () {
      let data = {
        id: null,
        ticket_id: this.$route.params.id,
        team_id: this.repair.team_id,
        repair_date: this.repair.repair_date,
        duration: this.repair.duration,
        repair_note: this.repair.repair_note
      }

      this.save(data).then(response => {
        if([ 200, 201 ].includes(response.status)) this.$router.push({
          name: 'dash.tickets.list',
          params: {
            notifications: [{
              variant: 'success',
              title: `Repair #${response.data.id}`,
              text: `The repair has been booked successfully.`,
              timeout: 2500
            }]
          }
        })
      })
    },

    fileChanged(fileKey) {
      this.repair.ticket[fileKey] = this[fileKey];
    },

    cancelRepair() {
      if(this.cancelRepairClicked) {
        axios.post(`/repairs/cancel/${this.repair.id}`).then(response => {
          if([ 200, 201 ].includes(response.status)) this.$router.push({
            name: 'dash.tickets.view',
            params: {
              notifications: [{
                variant: 'success',
                title: `Repair #${response.data.id}`,
                text: `The repair has been cancelled successfully.`,
                timeout: 2500
              }]
            }
          })
        })
      }else{
        this.cancelRepairClicked = true
        setTimeout(() => {
          this.cancelRepairClicked = false;
        } , 3000)
      }
    },

    returnFileUrl(fileKey) {
      if(this.repair.ticket[fileKey]) {
        return this.repair.ticket[fileKey].url ?? URL.createObjectURL(this.repair.ticket[fileKey]);
      }
    },

    returnTicketFileType(fileKey) {
      if(this.repair.ticket[fileKey]) {
        return this.repair.ticket[fileKey].mimetype.split('/')[0];
      }
    },

    returnTicketFileUrl(fileKey) {
      if(this.repair.ticket[fileKey]) {
        return this.repair.ticket[fileKey].url ?? URL.createObjectURL(this.repair.ticket[fileKey])
      }
    }
  },
  watch: {
    single () {
      this.repair = this.single
    }
  }
}
</script>

<style>

</style>
